import { FC, ReactNode, useContext } from "react";
import { useAtomValue } from "jotai";

import { Separator } from "@src/lib/ui/Separator";
import UndoRedoButtons from "@src/features/builders/shared/undoRedo/UndoRedoButtons";
import {
  BuilderActionContext,
  redoAvailableCountAtom,
  undoAvailableCountAtom,
} from "@src/features/libraryItem/contexts/BuilderActionContext";

/**
 * Floating pill that anchors to the bottom of a relative parent and hosts
 * builder-level controls (undo/redo, formatting, view modes, etc.). Shared
 * across Opus Docs, course builder, and future inline builders so they all
 * present a consistent surface.
 */
export const BuilderBottomToolbar: FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <div
      className="pointer-events-none absolute inset-x-0 bottom-3 z-[750] flex justify-center"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="pointer-events-auto flex items-center gap-1 rounded-full border border-gray-2 bg-white p-1.5 shadow-lg">
        {children}
      </div>
    </div>
  );
};

export const BuilderBottomToolbarSeparator: FC = () => (
  <Separator orientation="vertical" className="mx-1 h-6" />
);

export const BuilderBottomToolbarUndoRedo: FC = () => {
  const builderActionContext = useContext(BuilderActionContext);
  const undoAvailableCount = useAtomValue(undoAvailableCountAtom);
  const redoAvailableCount = useAtomValue(redoAvailableCountAtom);
  return (
    <UndoRedoButtons
      undo={() => builderActionContext?.undoAction()}
      redo={() => builderActionContext?.redoAction()}
      undoCount={undoAvailableCount}
      redoCount={redoAvailableCount}
    />
  );
};
